/**
 * Move focus so SPA navigation is announced (blueprint §5) without painting
 * a pointer-visible ring.
 *
 * Intent: every redesign route focuses its unique `<h1 tabindex="-1">` (or
 * an equivalent phase heading) on mount so screen readers hear a page load.
 * That focus is not a keyboard gesture.
 *
 * Constraint: Chromium in this project matches `:focus-visible` after a
 * plain `.focus()` on those headings, which paints the two-ring in
 * `primitives.css` on first paint — the "pre-selected on load" defect.
 * `focusVisible: false` is the engine-level opt-out; CSS still refuses a
 * ring on those headings even if an engine ignores the flag.
 *
 * Invariant: real controls (buttons, links, fields, radios) still show the
 * designed ring on Tab. Do not use this helper on those.
 *
 * Rejected: `outline: none` on `:focus-visible` (hides keyboard rings);
 * per-route `h1:focus { outline: none }` (misses the 6px box-shadow ring,
 * and only some screens had it).
 */
export function focusRouteStart(el: HTMLElement | null | undefined): void {
  // TypeScript's DOM lib in this repo does not yet list `focusVisible`.
  el?.focus({ preventScroll: true, focusVisible: false } as FocusOptions);
}
